// src/features/services/components/ServiceRow.tsx
import { ServiceStatusBadge } from './ServiceStatusBadge';

export type ServiceStatus = 'active' | 'expiring' | 'expired';

export interface Service {
  id: string;
  name: string;
  customerName: string;
  status: ServiceStatus;
  expiresAt: string;
}

interface ServiceRowProps {
  service: Service;
  onSelect?: ((service: Service) => void) | undefined;
  isSelected?: boolean;
}

/**
 * Selecting a row opens the Service Workspace for that service —
 * mirrors OrderRow exactly (button element, onSelect callback,
 * isSelected/aria-pressed for the currently open row).
 */
export function ServiceRow({ service, onSelect, isSelected = false }: ServiceRowProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect?.(service)}
      aria-pressed={isSelected}
      aria-label={`باز کردن فضای کاری سرویس ${service.customerName}`}
      className="flex w-full items-center gap-3 px-5 py-3.5 text-right"
    >
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-[var(--vania-colors-text-primary,#f5f6fa)]">
          {service.name}
        </p>
        <p className="truncate text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
          {service.customerName}
        </p>
      </div>

      <span className="shrink-0 text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
        {service.expiresAt}
      </span>

      <ServiceStatusBadge status={service.status} />
    </button>
  );
}
